import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Flex } from '@chakra-ui/react'
import { Container, PageTitle, Content } from 'src/components/Layout'
import List from 'src/components/List/List'
import { Loader } from 'src/components/Loader'
import intlMessages from '../translations'
import intlMessagesDocuments from 'src/modules/Documents/translations'
import { capitalize } from 'src/utils/helpers'

class Vehicles extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidMount() {
    this.props.getVehicles()
  }

  getVehiclesList = (vehicles = []) => {
    return vehicles.reduce((result, vehicle) => {
      return [
        ...result,
        {
          leftIcon: 'Vehicle',
          name: vehicle.year,
          description: `${vehicle.make} ${vehicle.model} ${vehicle.vin}`,
          url: '/claims/form',
          rightIcon: 'right',
          hideArrow: true,
          hideArrowOnMobile: true,
        },
      ]
    }, [])
  }

  handleBack = () => {
    this.props.history.push('/claims/form')
  }

  handleClick = item => {
    this.props.setVehicle({ name: item.name, description: item.description })
    this.props.history.push(item.url)
  }

  render() {
    const { vehicles, intl, loading } = this.props
    return (
      <Flex className='m-claims-vehicles claims-list'>
        <Content>
          <PageTitle
            title={capitalize(intl.formatMessage(intlMessages.claimsVehicles))}
            subtitle={intl.formatMessage(intlMessages.claimsFillOutTheForm)}
          />
          <Container>
            {loading ? (
              <Loader styleVariation='staticWithHeight' addDesktopBackgroundColor={true} />
            ) : (
              <List
                isColumn={true}
                noMargin={true}
                items={this.getVehiclesList(vehicles)}
                onClick={this.handleClick}
                noResultsMessage={intl.formatMessage(
                  intlMessagesDocuments.documentRemoveVehicleNoResults,
                )}
              />
            )}
          </Container>
        </Content>
      </Flex>
    )
  }
}

export default injectIntl(Vehicles)
